import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    const textarea = this.element.querySelector("textarea")
    if (textarea && !textarea.value.trim()) {
      event.preventDefault()
    }
  }

  submitOnEnter(event) {
    // Enter sends, Shift+Enter inserts newline
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }

  reset() {
    const textarea = this.element.querySelector("textarea")
    if (textarea) {
      textarea.value = ""
      textarea.style.height = "auto"
      textarea.focus()
    }
  }
}
